const joinWithCommas = (
  a: string[],
  str: string = "and",
  empty: string = ""
) => {
  if (a.length === 0) return empty;
  if (a.length === 1) return a[0];
  if (a.length === 2) return `${a[0]} ${str} ${a[1]}`;
  return `${a.slice(0, a.length - 1).join(", ")}, ${str} ${a[a.length - 1]}`;
};

export default joinWithCommas;
